import PropTypes from 'prop-types';
import { BLOCKS } from '@contentful/rich-text-types';

import RichText, { fragment } from '../../../Core/RichText';
import Container from '../../../Core/Container';
import { isNotEmpty } from '../../../../utils';

import {
  CDIC,
  Img,
  ImageWrapper,
  Body,
  Wrapper,
  Content,
  StyledParagraph,
  Olist,
  Ulist,
  StyledLink,
} from './styles';

const PCMoneyCDIC = ({ data, className = '' }) => {
  if (!data) return null;

  const {
    anchorName,
    component,
    heading,
    headingStyle,
    bodyCopy,
    ctas,
    imageDam,
  } = data;

  const richTextContentAsTitle = (_, children) =>
    isNotEmpty(children) ? <h2 className={headingStyle}>{children}</h2> : null;

  const title = {
    renderNode: {
      [BLOCKS.PARAGRAPH]: richTextContentAsTitle,
      [BLOCKS.HEADING_1]: richTextContentAsTitle,
      [BLOCKS.HEADING_2]: richTextContentAsTitle,
      [BLOCKS.HEADING_3]: richTextContentAsTitle,
      [BLOCKS.HEADING_4]: richTextContentAsTitle,
      [BLOCKS.HEADING_5]: richTextContentAsTitle,
      [BLOCKS.HEADING_6]: richTextContentAsTitle,
    },
  };

  const body = {
    renderNode: {
      [BLOCKS.PARAGRAPH]: (_, children) => (
        <StyledParagraph>{children}</StyledParagraph>
      ),
      [BLOCKS.OL_LIST]: (_, children) => <Olist>{children}</Olist>,
      [BLOCKS.UL_LIST]: (_, children) => <Ulist>{children}</Ulist>,
    },
  };

  return (
    <Container className={className || component} id={anchorName}>
      <Wrapper>
        <CDIC>
          {imageDam && (
            <ImageWrapper>
              <Img src={imageDam} alt={imageDam.altText || ''} />
            </ImageWrapper>
          )}
        </CDIC>
        <Content>
          {heading && <RichText document={heading} options={title} />}
          <Body>
            {bodyCopy && <RichText document={bodyCopy} options={body} />}
            {ctas &&
              ctas.map(cta => {
                if (cta.hideFrench === true) return null;
                return (
                  <StyledLink key={cta.id} data={cta}>
                    <RichText document={cta.label} options={fragment} />
                  </StyledLink>
                );
              })}
          </Body>
        </Content>
      </Wrapper>
    </Container>
  );
};

PCMoneyCDIC.propTypes = {
  data: PropTypes.shape().isRequired,
  className: PropTypes.string,
};

export default PCMoneyCDIC;
